import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("published", "New Arrivals", { field: "datePublished", order: "desc" }),
    createSortOption("ratingValue", "Top Rated", { field: "ratingValue", order: "desc" }),
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}
